import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "base-form form",
  style: {"margin":"0 0 2rem","min-width":"100%"}
}
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = { style: {"flex-wrap":"wrap"} }
const _hoisted_4 = { class: "order-jobs-table el-table--fit el-table--enable-row-transition has-footer el-table el-table--layout-fixed is-scrolling-none" }
const _hoisted_5 = { class: "el-table__inner-wrapper" }
const _hoisted_6 = {
  class: "el-table__header",
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  style: {"width":"100%"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_9 is-leaf el-table__cell",
      width: "1%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" })
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_9 is-leaf el-table__cell",
      width: "74px"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" })
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_10 is-leaf el-table__cell",
      width: "18%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Компонент")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_11 is-leaf el-table__cell",
      width: "14%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Операция")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_12 is-leaf el-table__cell",
      width: "8%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Стоимость НЧ")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_13 is-leaf el-table__cell",
      width: "8%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Кол-во часов")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_16 is-leaf el-table__cell",
      width: "8%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Скидка (%)")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_16 is-leaf el-table__cell",
      width: "8%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Менеджер")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_16 is-leaf el-table__cell",
      width: "8%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Начало работы")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_16 is-leaf el-table__cell",
      width: "8%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Завершение работы")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_17 is-leaf el-table__cell",
      width: "8%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Итого (р.)")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_18 is-leaf el-table__cell",
      width: "8%"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Субподряд")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "el-table_2_column_19 is-leaf el-table__cell",
      width: "74px"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "cell" })
    ])
  ])
], -1)
const _hoisted_8 = {
  width: "100%",
  colspan: "13"
}
const _hoisted_9 = {
  cellpadding: "0",
  cellspacing: "0",
  width: "100%"
}
const _hoisted_10 = {
  width: "1%",
  class: "el-table__cell"
}
const _hoisted_11 = { class: "cell" }
const _hoisted_12 = {
  width: "74px",
  class: "el-table__cell"
}
const _hoisted_13 = { class: "cell" }
const _hoisted_14 = {
  width: "18%",
  class: "el-table__cell"
}
const _hoisted_15 = { class: "cell" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  width: "14%",
  class: "el-table__cell"
}
const _hoisted_18 = { class: "cell" }
const _hoisted_19 = {
  width: "8%",
  class: "el-table__cell"
}
const _hoisted_20 = { class: "cell" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  width: "8%",
  class: "el-table__cell"
}
const _hoisted_23 = { class: "cell" }
const _hoisted_24 = {
  width: "8%",
  class: "el-table__cell"
}
const _hoisted_25 = {
  width: "8%",
  class: "el-table__cell"
}
const _hoisted_26 = { class: "cell" }
const _hoisted_27 = {
  width: "8%",
  class: "el-table__cell"
}
const _hoisted_28 = { class: "cell" }
const _hoisted_29 = {
  width: "8%",
  class: "el-table__cell"
}
const _hoisted_30 = { class: "cell" }
const _hoisted_31 = {
  width: "8%",
  class: "el-table__cell"
}
const _hoisted_32 = { class: "cell" }
const _hoisted_33 = {
  width: "8%",
  class: "el-table__cell"
}
const _hoisted_34 = { class: "cell" }
const _hoisted_35 = {
  width: "74px",
  class: "el-table__cell"
}
const _hoisted_36 = { class: "cell" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  class: "el-table_2_column_16 el-table__cell",
  colspan: "10",
  align: "center"
}
const _hoisted_40 = { class: "cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_order_jobs_search_component = _resolveComponent("order-jobs-search-component")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_order_auto_schedule_jobs_component = _resolveComponent("order-auto-schedule-jobs-component")!
  const _component_order_timeline_modal_component = _resolveComponent("order-timeline-modal-component")!
  const _component_expand_button_component = _resolveComponent("expand-button-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_order_job_assignees_table_component = _resolveComponent("order-job-assignees-table-component")!
  const _component_table_draggable_component = _resolveComponent("table-draggable-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }),
        _createVNode(_component_el_col, {
          span: 8,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_order_jobs_search_component, { onPicked: _ctx.onJobPicked }, null, 8, ["onPicked"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_order_auto_schedule_jobs_component, {
                    order: _ctx.order,
                    onScheduled: _ctx.onJobsAssigneesAutoScheduled
                  }, null, 8, ["order", "onScheduled"])
                ]),
                _createTextVNode("   "),
                _createVNode(_component_order_timeline_modal_component, {
                  "schedule-date": _ctx.order.scheduledStartDate,
                  order: _ctx.order,
                  "load-schedule-async-handler": _ctx.loadJobsScheduleAsyncDelegate,
                  onItemUpdated: _ctx.onJobAssigneeScheduleUpdate
                }, null, 8, ["schedule-date", "order", "load-schedule-async-handler", "onItemUpdated"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _hoisted_7,
                  (_ctx.orderJobs?.length)
                    ? (_openBlock(), _createBlock(_component_table_draggable_component, {
                        key: 0,
                        items: _ctx.orderJobs,
                        "onUpdate:items": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderJobs) = $event)),
                        onReordered: _ctx.emitJobsUpdate
                      }, {
                        item: _withCtx(({ element: job, index }) => [
                          _createElementVNode("td", _hoisted_8, [
                            _createElementVNode("table", _hoisted_9, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_expand_button_component, {
                                        modelValue: job.jobExpanded,
                                        "onUpdate:modelValue": ($event: any) => ((job.jobExpanded) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(_component_el_button, {
                                        icon: _ctx.filesIcon,
                                        circle: "",
                                        onClick: (e) => _ctx.onTableCloneJobClick(job, e)
                                      }, null, 8, ["icon", "onClick"])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createTextVNode(_toDisplayString(job.serviceJob!.component.name) + " ", 1),
                                      ( job.serviceJob!.component.componentGroup)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createVNode(_component_el_text, {
                                              type: "info",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(job.serviceJob!.component.componentGroup.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_el_select, {
                                        modelValue: job.serviceJob!.operation.id,
                                        "onUpdate:modelValue": ($event: any) => ((job.serviceJob!.operation.id) = $event),
                                        onChange: (i) => _ctx.onTableJobOperationChange(i, job),
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.availableOperations, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              disabled: _ctx.checkComponentOperationDisabled(job, item.id),
                                              key: item.id,
                                              label: item.name,
                                              value: item.id
                                            }, null, 8, ["disabled", "label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      (!job.isOverriddingCostPerHour)
                                        ? (_openBlock(), _createBlock(_component_el_link, {
                                            key: 0,
                                            type: "primary",
                                            underline: false,
                                            onClick: (e) => _ctx.onTableJobCostEditClick(job, e)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(job.overriddenJobCostPerHour ? job.overriddenJobCostPerHour :  job.serviceJob!.category.costPerHour) + " руб. ", 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createVNode(_component_el_input_number, {
                                              size: "small",
                                              onClick: _cache[0] || (_cache[0] = (e) => e.stopPropagation()),
                                              onKeydown: _withKeys((e) => _ctx.onTableJobCancelCostEditClick(job, e), ["esc"]),
                                              onChange: () => _ctx.updateJobPrice(job),
                                              modelValue: job.overriddenJobCostPerHour,
                                              "onUpdate:modelValue": ($event: any) => ((job.overriddenJobCostPerHour) = $event),
                                              min: 0
                                            }, null, 8, ["onKeydown", "onChange", "modelValue", "onUpdate:modelValue"])
                                          ]))
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(_component_el_input_number, {
                                        size: "small",
                                        onClick: _cache[1] || (_cache[1] = (e) => e.stopPropagation()),
                                        onChange: () => _ctx.updateJobPrice(job),
                                        class: _normalizeClass({'input-invalid': job.estimationHrsInvalid}),
                                        modelValue: job.estimationHrs,
                                        "onUpdate:modelValue": ($event: any) => ((job.estimationHrs) = $event),
                                        min: 0
                                      }, null, 8, ["onChange", "class", "modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_24, [
                                    _createVNode(_component_el_input_number, {
                                      size: "small",
                                      onChange: () => _ctx.updateJobPrice(job),
                                      modelValue: job.discountPercent,
                                      "onUpdate:modelValue": ($event: any) => ((job.discountPercent) = $event),
                                      min: -100,
                                      max: 100
                                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, _toDisplayString(job.manager?.lastname) + " " + _toDisplayString(`${job.manager?.firstname ? `${job.manager?.firstname?.substring(0,1)}.` : ''}`), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatJobScheduledStartDate(job)), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.formatJobScheduledEndDate(job)), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, _toDisplayString(job.cost), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createVNode(_component_el_checkbox, {
                                        modelValue: job.isSubcontract,
                                        "onUpdate:modelValue": [($event: any) => ((job.isSubcontract) = $event), () => _ctx.onTableSubcontractChanged(job)]
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                      _createVNode(_component_el_button, {
                                        icon: _ctx.deleteIcon,
                                        circle: "",
                                        onClick: (e) => _ctx.onTableDeleteJobClick(index, e)
                                      }, null, 8, ["icon", "onClick"])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            (job.jobExpanded)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _createVNode(_component_order_job_assignees_table_component, {
                                    job: job,
                                    "branch-id": _ctx.order.executiveEntityBranch?.id,
                                    modelValue: job.assignees,
                                    "onUpdate:modelValue": [($event: any) => ((job.assignees) = $event), _ctx.emitJobsUpdate]
                                  }, null, 8, ["job", "branch-id", "modelValue", "onUpdate:modelValue"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["items", "onReordered"]))
                    : _createCommentVNode("", true),
                  (!_ctx.orderJobs?.length)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_el_text, { type: "info" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("В заказ-наряде нет работ ☹️")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}